// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__kXlYa {
  background: rgba(0, 0, 0, 0.3);
  padding: 4rem 0 2rem;
}

.Footer_content__aJpHx {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4rem;
  margin-bottom: 3rem;
}
.Footer_brand__QKAvM {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.Footer_brand__QKAvM h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.Footer_brand__QKAvM p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.Footer_links__wMgLO {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.Footer_linkGroup__5kctw h4 {
  color: var(--text);
  margin-bottom: 1rem;
  font-size: 1rem;
}

.Footer_linkGroup__5kctw ul {
  list-style: none;
  padding: 0;
}

.Footer_linkGroup__5kctw li {
  margin-bottom: 0.5rem;
}

.Footer_linkGroup__5kctw a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.Footer_linkGroup__5kctw a:hover {
  color: var(--text);
}

.Footer_bottom__7buk6 {
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Footer_bottom__7buk6 p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.Footer_legal__fy6ps {
  display: flex;
  gap: 1.5rem;
}

.Footer_legal__fy6ps a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.Footer_legal__fy6ps a:hover {
  color: var(--text);
}

@media (max-width: 768px) {
  .Footer_content__aJpHx {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .Footer_links__wMgLO {
    grid-template-columns: 1fr;
  }
  
  .Footer_bottom__7buk6 {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .Footer_legal__fy6ps {
    justify-content: center;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oEAAoE;EACpE,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".footer {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 4rem 0 2rem;\n}\n\n.content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 4rem;\n  margin-bottom: 3rem;\n}\n.brand {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.brand h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.brand p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.links {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.linkGroup h4 {\n  color: var(--text);\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.linkGroup ul {\n  list-style: none;\n  padding: 0;\n}\n\n.linkGroup li {\n  margin-bottom: 0.5rem;\n}\n\n.linkGroup a {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.linkGroup a:hover {\n  color: var(--text);\n}\n\n.bottom {\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bottom p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.legal {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.legal a {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.legal a:hover {\n  color: var(--text);\n}\n\n@media (max-width: 768px) {\n  .content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n  \n  .links {\n    grid-template-columns: 1fr;\n  }\n  \n  .bottom {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .legal {\n    justify-content: center;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__kXlYa`,
	"content": `Footer_content__aJpHx`,
	"brand": `Footer_brand__QKAvM`,
	"links": `Footer_links__wMgLO`,
	"linkGroup": `Footer_linkGroup__5kctw`,
	"bottom": `Footer_bottom__7buk6`,
	"legal": `Footer_legal__fy6ps`
};
export default ___CSS_LOADER_EXPORT___;
